import TakerSkillsBreakdownBar from "pages/PanelPage/components/charts/TakerSkillsBreakdownBar/TakerSkillsBreakdownBar";

export default TakerSkillsBreakdownBar;
